import { render, staticRenderFns } from "./BaseListItemPhoneNumber.vue?vue&type=template&id=30ab8494&scoped=true&"
import script from "./BaseListItemPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./BaseListItemPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab8494",
  null
  
)

export default component.exports